import { defineType } from "sanity";

export default defineType({
  name: "dateTokenValue",
  title: "Date Token Value",
  type: "object",
  preview: {
    select: {
      name: "name",
      value: "value"
    },
    prepare({ name, value }) {
      return {
        title: name,
        subtitle: value
      };
    }
  },
  fields: [
    {
      name: "name",
      title: "Token name",
      type: "string",
      validation: (Rule) => Rule.required()
    },
    {
      name: "value",
      title: "Value",
      type: "date",
      validation: (Rule) => Rule.required()
    }
  ]
});
